import { z, ZodIssueCode } from 'zod'

const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.message) {
    return { message: issue.message }
  }

  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === 'undefined') {
        return { message: 'Requerido' }
      }
      return {
        message: `Tipo inválido. Se esperaba ${issue.expected} pero se recibió ${issue.received}`
      }

    case ZodIssueCode.invalid_literal:
      return {
        message: `Valor inválido. Se esperaba ${JSON.stringify(issue.expected)}`
      }

    case ZodIssueCode.unrecognized_keys:
      return {
        message: `Claves no reconocidas en el objeto: ${issue.keys.join(', ')}`
      }

    case ZodIssueCode.invalid_union_discriminator:
      return {
        message: `Valor de discriminador inválido. Se esperaba ${issue.options.join(' | ')}`
      }

    case ZodIssueCode.invalid_enum_value:
      return {
        message: `Valor de enum inválido. Se esperaba ${issue.options.join(' | ')}`
      }

    case ZodIssueCode.invalid_return_type:
      return { message: `Tipo de retorno de función inválido` }

    case ZodIssueCode.invalid_date:
      return { message: `Fecha inválida` }

    case ZodIssueCode.invalid_string:
      if (issue.validation === 'email')
        return { message: `Correo electrónico inválido` }
      if (issue.validation === 'url') return { message: `URL inválida` }
      if (issue.validation === 'regex') return { message: `Formato inválido` }
      return { message: `Inválido` }

    default:
      return { message: ctx.defaultError }
  }
}

z.setErrorMap(customErrorMap)
export { z }
